<div class="button-toggle">
  <div *ngIf="hasCaption"
       class="button-toggle__label">
    {{ fieldConfig.caption | translate }}
  </div>

  <div class="button-toggle__buttons">
    <mat-button-toggle-group id="{{fieldConfig.fieldKey}}"
                             (change)="onChange($event)"
                             (click)="onClick($event)"
                             [formControl]="control">
      <ng-container *ngFor="let option of fieldConfig.radioConfig">
        <mat-button-toggle [value]="option.value">
          {{ option.label | translate }}
        </mat-button-toggle>
      </ng-container>
    </mat-button-toggle-group>
  </div>
</div>
